import { createSelector } from '@ngrx/store';

import { surveyFeature } from '../survey.feature';

const { selectReference } = surveyFeature;

export const selectBuyerProjectManagers = createSelector(
  selectReference,
  ({ buyerProjectManagers }) => buyerProjectManagers,
);

export const selectOperatorProjectManagers = createSelector(
  selectReference,
  ({ operatorProjectManagers }) => operatorProjectManagers,
);

export const selectBuyerPmCachedAt = createSelector(
  selectReference,
  ({ buyerPmCachedAt }) => buyerPmCachedAt,
);

export const selectOperatorPmCachedAt = createSelector(
  selectReference,
  ({ operatorPmCachedAt }) => operatorPmCachedAt,
);

export const selectTransactionStatuses = createSelector(
  selectReference,
  ({ transactionStatuses }) => transactionStatuses,
);

export const selectTransactionStatusesCachedAt = createSelector(
  selectReference,
  ({ transactionStatusesCachedAt }) => transactionStatusesCachedAt,
);

export const selectBuyerSettings = createSelector(
  selectReference,
  ({ buyerSettings }) => buyerSettings,
);

export const selectBuyerSettingsCachedAt = createSelector(
  selectReference,
  ({ buyerSettingsCachedAt }) => buyerSettingsCachedAt,
);

export const selectIsDownloadingSurveyReport = createSelector(
  selectReference,
  ({ isDownloadingSurveyReport }) => isDownloadingSurveyReport,
);

export const selectIsDownloadingSupplierSummary = createSelector(
  selectReference,
  ({ isDownloadingSupplierSummary }) => isDownloadingSupplierSummary,
);

export const selectIsDownloadingCsReport = createSelector(
  selectReference,
  ({ isDownloadingCsReport }) => isDownloadingCsReport,
);
